import { render, staticRenderFns } from "./FullPagePrincipalDashboard.vue?vue&type=template&id=0447d08c&"
import script from "./FullPagePrincipalDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPagePrincipalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FullPagePrincipalDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports